/**
 * Demo Profile definitions — each profile provides industry-specific
 * mock data for portfolios, projects, contracts, risks, resources, etc.
 */

export interface DemoProfile {
  id: string
  name: string
  description: string
  industry: string
  icon: string // Lucide icon name
  color: string // Tailwind color class
  bgColor: string // Tailwind bg + border class
  /** Subdirectory under /mockdata/profiles/ that holds the JSON files */
  dataDir: string
  /** Supabase Auth credentials for this demo profile (auto-sign-in) */
  demoAuth?: { email: string; password: string }
}

export const DEMO_PROFILES: DemoProfile[] = [
  {
    id: 'technology-digital',
    name: 'Technology & Digital',
    description: 'Cloud migrations, ERP upgrades, cybersecurity, and digital transformation programs',
    industry: 'Information Technology',
    icon: 'Monitor',
    color: 'text-blue-700',
    bgColor: 'bg-blue-50 border-blue-200',
    dataDir: '', // root mockdata — existing data
    demoAuth: { email: 'demo-tech@tessaractxpm.com', password: 'demo-tech-2025!' },
  },
  {
    id: 'engineering-construction',
    name: 'Engineering & Construction',
    description: 'Highway infrastructure, commercial buildings, water treatment facilities, and capital improvement programs',
    industry: 'Engineering & Construction',
    icon: 'HardHat',
    color: 'text-orange-700',
    bgColor: 'bg-orange-50 border-orange-200',
    dataDir: 'profiles/engineering-construction',
    demoAuth: { email: 'demo-ec@tessaractxpm.com', password: 'demo-ec-2025!' },
  },
  {
    id: 'aerospace-defense',
    name: 'Aerospace & Defense',
    description: 'Commercial aircraft supply programs, OEM long-term agreements, AS9100 / DO-160 certification, and advanced materials R&D',
    industry: 'Aerospace & Defense',
    icon: 'Rocket',
    color: 'text-slate-900',
    bgColor: 'bg-slate-200 border-slate-500',
    dataDir: 'profiles/aerospace-defense',
    demoAuth: { email: 'demo-asd@tessaractxpm.com', password: 'demo-asd-2025!' },
  },
]

export function getDemoProfile(id: string): DemoProfile {
  return DEMO_PROFILES.find(p => p.id === id) ?? DEMO_PROFILES[0]!
}

// Demo persona accounts all live on the @tessaractxpm.com domain. Real users
// authenticate with their own domains. This distinguishes "a real person logged
// in through the wall" (bind their roster identity, land them in a real mode)
// from "a demo-account session" (keep the demo experience). A demo account is
// SHARED: whoever picks the profile signs in as it.
export function isDemoAuthAccount(email: string | null | undefined): boolean {
  return !!email && email.toLowerCase().endsWith('@tessaractxpm.com')
}
